











import { defineComponent, PropType } from '@vue/composition-api';
import { Mod, ModTag } from '@c/landingpage/modpack/types';
import { useI18N } from '@a/composables/use-vue-i18n';

export default defineComponent({
  name: 'BaseModpackTagList',
  props: {
    modTags: {
      type: Array as PropType<Array<String>>,
      required: true,
    },
    tags: {
      type: Array as PropType<Array<ModTag>>,
      required: true,
    },
  },
  setup: (props) => {
    const i18n = useI18N();
    const getTagBySlug = (slug: string) : ModTag => props.tags.find((tag) => tag.slug === slug);

    const tagList : Array<ModTag> = props.modTags.map((slug : String) => getTagBySlug(slug));

    return {
      i18n,
      tagList,
    };
  },
});
